// @ts-nocheck
/**
 * Create Break — dead-shipped in v1 (router mounts without required props).
 * ACTUAL Create UI lives inline in BreaksListPage. This component is kept
 * for route parity. `type` hard-coded to 'Scheduled' (Scheduled/Unscheduled
 * UI is disabled).
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const CreateBreak = ({ show, handleClose, handleCreate }: any) => {
  const [breakData, setBreakData] = useState<any>({
    title: '',
    duration: '',
    description: '',
    status: true,
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setBreakData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    handleCreate({
      ...breakData,
      type: 'Scheduled',
    });
    handleClose();
  };

  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && handleClose?.()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Break</DialogTitle>
        </DialogHeader>
        <form>
          <div className="mb-3 space-y-2">
            <label className="text-sm font-medium leading-none">Break Title</label>
            <Input
              type="text"
              name="title"
              value={breakData.title}
              onChange={handleChange}
              placeholder="Enter break title"
            />
          </div>

          <div className="mb-3 space-y-2">
            <label className="text-sm font-medium leading-none">
              Break Duration (In Minutes)
            </label>
            <Input
              type="number"
              name="duration"
              value={breakData.duration}
              onChange={handleChange}
              placeholder="Enter duration in minutes"
              min="1"
              max="1440"
              step="1"
              onKeyDown={(e: any) => {
                if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                  e.preventDefault();
                }
              }}
              onPaste={(e: any) => {
                const pastedValue = e.clipboardData.getData('text');
                const numValue = Number(pastedValue);
                if (
                  isNaN(numValue) ||
                  numValue <= 0 ||
                  numValue > 1440 ||
                  !Number.isInteger(numValue)
                ) {
                  e.preventDefault();
                }
              }}
            />
          </div>

          <div className="mb-3 space-y-2">
            <label className="text-sm font-medium leading-none">Break Description</label>
            <textarea
              className="form-control"
              rows={3}
              name="description"
              value={breakData.description}
              onChange={handleChange}
              placeholder="Enter description (optional)"
            />
          </div>
        </form>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Discard Changes
          </Button>
          <Button onClick={handleSubmit}>Create Break</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateBreak;
